import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleLeft } from "@fortawesome/free-solid-svg-icons";
import ErrorHandler from "../../helpers/ErrorHandler";
import { AxiosInstance } from "axios";
import { NotificationMessage } from "../../helpers/Types";

interface ActivityTriggerCreateProps {
  setNotificationMessage: (notificationMessage: NotificationMessage) => void;
  api: AxiosInstance;
  updateUsername: (username: string) => void;
}

export default function ActivityTriggerCreate({
  setNotificationMessage,
  api,
  updateUsername,
}: ActivityTriggerCreateProps) {
  const navigate = useNavigate();
  const [triggerName, setTriggerName] = useState("");

  function saveChanges(e: FormEvent) {
    e.preventDefault();
    var postData = {
      trigger_name: triggerName,
    };
    api
      .post(`/activity/trigger/create`, JSON.stringify(postData), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        setNotificationMessage({ class: "success", message: "Saved successfully" });
        navigate(`/activity/trigger`);
      })
      .catch((error) => {
        ErrorHandler(error, setNotificationMessage);
        updateUsername("");
      });
  }

  return (
    <div className="p-3 m-1 border rounded bg-white">
      <div className="pb-3">
        <Link className="text-decoration-none bold" to={{ pathname: `/activity/trigger` }}>
          <FontAwesomeIcon icon={faArrowAltCircleLeft} size="lg" />
        </Link>
      </div>
      <form onSubmit={saveChanges}>
        <div className="mb-3">
          <label htmlFor="trigger-edit-name" className="form-label">
            Trigger Name
          </label>
          <input
            id="trigger-edit-name"
            className="form-control"
            type="text"
            value={triggerName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTriggerName(e.target.value)}
          />
        </div>
        <input type="submit" className="btn btn-primary" />
      </form>
    </div>
  );
}
